/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const submitCheckoutBodyImagesMax = 10;

export const submitCheckoutBodyTextsMax = 10;

export const SubmitCheckoutBody = zod
	.object({
		'images[]': zod
			.array(zod.instanceof(File))
			.max(submitCheckoutBodyImagesMax)
			.optional()
			.describe('Array of image files to be moderated'),
		'metadata': zod.looseObject({}).optional().describe('Additional metadata'),
		'texts[]': zod
			.array(zod.instanceof(File))
			.max(submitCheckoutBodyTextsMax)
			.optional()
			.describe('Array of text content to be moderated')
	})
	.describe('Multipart form data for content submission');

export type SubmitCheckoutBody = zod.input<typeof SubmitCheckoutBody>;
export type SubmitCheckoutBodyOutput = zod.output<typeof SubmitCheckoutBody>;
